
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const excelExportUtils = (
  data: any[],
  fileName: string,
  sheetName: string,
  footerRow?: Record<string, any>
) => {
  if (!data || !data.length) {
    console.warn("No data available to export.");
    return;
  }

  const tableData = [...data];
  if (footerRow) {
    tableData.push(footerRow);
  }

  const worksheet = XLSX.utils.json_to_sheet(tableData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName || "Sheet1");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(blob, `${fileName}.xlsx`);
};
